const RECEIPT_PAD_LENGTH = 6;

export const getReceiptCandidates = (rawInput = '') => {
  const trimmed = rawInput.trim();
  if (!trimmed) return [];

  const candidates = new Set([trimmed]);
  const digitsOnly = trimmed.replace(/\D/g, '');
  if (digitsOnly) {
    candidates.add(digitsOnly);
  }

  if (/^\d+$/.test(digitsOnly) && digitsOnly.length >= RECEIPT_PAD_LENGTH) {
    const variants = new Set([digitsOnly]);
    if (digitsOnly.length > RECEIPT_PAD_LENGTH) {
      variants.add(digitsOnly.slice(0, -1));
    }
    if (digitsOnly.length === 13) {
      variants.add(digitsOnly.slice(0, -1));
    }
    variants.forEach((str) => {
      if (!str) return;
      candidates.add(str);
      const noLeadingZeros = str.replace(/^0+/, '') || '0';
      candidates.add(noLeadingZeros);
      candidates.add(
        str
          .slice(-RECEIPT_PAD_LENGTH)
          .padStart(RECEIPT_PAD_LENGTH, '0')
      );
    });
  }

  return Array.from(candidates).filter(Boolean);
};

export const normalizeReceiptNumber = (rawInput = '') => {
  const candidates = getReceiptCandidates(rawInput);
  const numeric = candidates
    .filter((candidate) => /^\d+$/.test(candidate))
    .map((candidate) => {
      const trimmed = candidate.replace(/^0+/, '') || '0';
      const padded = trimmed.slice(-RECEIPT_PAD_LENGTH).padStart(RECEIPT_PAD_LENGTH, '0');
      return {
        original: candidate,
        trimmedLength: trimmed.length,
        padded,
      };
    })
    .sort((a, b) => a.trimmedLength - b.trimmedLength || a.padded.localeCompare(b.padded));

  if (numeric.length > 0) {
    return numeric[0].padded;
  }

  return candidates[0] || '';
};
